export const BANNER_HEIGHT = 'h-[16rem]';
